"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _default = function _default() {
  _classCallCheck(this, _default);

  // eslint-disable-next-line
  var self = this;
  this.emcm = {
    authPageLocation: null,
    location: null,
    loginUrl: null,
    logoutUrl: null,
    cors: false
  };
  this.estore = {
    location: null,

    get cartUrl() {
      if (this.cartUrlInternal) {
        return this.cartUrlInternal;
      }

      return "".concat(this.location, "/cart");
    },

    set cartUrl(value) {
      this.cartUrlInternal = value;
    }

  };
  this.identityService = {
    clientId: null,
    location: null,

    get loginUrl() {
      if (this.loginUrlInternal) {
        return this.loginUrlInternal;
      }

      var callbackUrl = encodeURIComponent("".concat(self.emcm.authPageLocation, "?action=login"));
      return "".concat(this.location, "/token?iss=").concat(this.clientId, "&services=").concat(this.clientId, "&provider=onepass&callback_url=").concat(callbackUrl);
    },

    set loginUrl(value) {
      this.loginUrlInternal = value;
    }

  };
  this.onepass = {
    location: null,
    productId: null,

    get transferUrl() {
      if (this.transferUrlInternal) {
        return this.transferUrlInternal;
      }

      var identityServiceTransferUrl = "".concat(self.identityService.location, "/auth/onepass/").concat(self.identityService.clientId, "/transfertoken");
      return "".concat(this.location, "?productid=").concat(this.productId, "&returnto=").concat(encodeURIComponent(identityServiceTransferUrl));
    },

    set transferUrl(value) {
      this.transferUrlInternal = value;
    }

  };
  this.site = {
    accountOverviewUrl: null
  };
  this.transferIframeLocations = [];
  this.signoutIframeLocations = [];
  this.redirectUrlSessionKey = "emcmLoginRedirectURL";
};

exports["default"] = _default;